import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import styled from 'styled-components';
import { toggleNav } from 'shared/store/modules/nav/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getIsNavOpen } from 'shared/store/modules/nav/selectors';
import Icon from 'shared/components/Icon';
import { CustomerType, UserRole } from 'shared/models';
import CustomerAllocationStatus from 'shared/models/enums/CustomerAllocationStatus';

const NavIcon = styled(Icon)`
  margin-right: 10px;
`;

type CustomerNavigationProps = {
  account: any;
  isUtilityBilled?: boolean;
  navigation: { url: string; icon: string; title: string }[];
};

type NavItemConfig = {
  to: string;
  icon: string;
  title: string;
  condition?: boolean;
  exact?: boolean;
};

export const CustomerNavigation = (props: CustomerNavigationProps) => {
  const { account, isUtilityBilled, navigation } = props;
  const dispatch = useDispatch();
  const isNavOpen = useSelector(getIsNavOpen);

  const isAccountManager = account.role === UserRole['Account Manager'];
  const isAllocated = account.customerAllocationStatus === CustomerAllocationStatus.Allocated;
  const isProvisional = account.customerType === CustomerType.Provisional;

  const primaryNavItems: NavItemConfig[] = [
    {
      to: '/',
      icon: 'dashboard',
      title: 'Dashboard',
      exact: true
    },
    {
      to: '/account-activity',
      icon: 'attach_money',
      title: isUtilityBilled ? 'Account Activity' : 'Payments',
      condition: isAccountManager
    },
    {
      to: '/subscription',
      icon: 'sunny',
      title: 'Subscription',
      condition: isAllocated || isProvisional
    },
    {
      to: '/projects',
      icon: 'layers',
      title: 'Solar Projects',
      condition: isAllocated
    },
    {
      to: '/settings',
      icon: 'settings',
      title: 'Account Settings',
      condition: isAccountManager
    },
    {
      to: '/documents',
      icon: 'description',
      title: 'Documents',
      condition: !isAllocated
    }
  ];

  const renderNavItem = (item: NavItemConfig, index: number) => {
    if (item.condition === false) return null;

    return (
      <NavItem key={`primary-nav-${index}`} onClick={() => (isNavOpen ? dispatch(toggleNav()) : {})}>
        <NavLink exact={item.exact} tag={Link} to={item.to}>
          <NavIcon icon={item.icon} /> {item.title}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <>
      <Nav className="navigation-primary" vertical>
        {primaryNavItems.map(renderNavItem)}
      </Nav>

      {!!navigation.length && (
        <Nav className="navigation-secondary" vertical>
          {navigation.map((nav, index) => (
            <NavItem key={`secondary-nav-${index}`} onClick={() => (isNavOpen ? dispatch(toggleNav()) : {})}>
              <NavLink href={nav.url} target="_blank">
                <NavIcon icon={nav.icon} /> {nav.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      )}
    </>
  );
};
